import { Button, Container, Grid, Header, Message } from "semantic-ui-react";
import tglh from '../assets/tglh.png';
import { QRCode } from 'react-qrcode-logo';
export function AllowMembersSetScores(value) {


  function downloadQRCode() {

    let canvas = document.querySelector("#qrCodeContainer canvas"); // Pobiera pierwsze <canvas> wewnątrz div-a
  if (!canvas) return;
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = value ? value + `.png` : "";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

  };

  return <Container >


    <Message>
      <Message.Header>Instrukcja logowania</Message.Header>
      <Grid>
        <Grid.Row >
          <Grid.Column width={8}>
            <p>
              Aby zalogować się do panelu menagera pojedynków, wykonaj poniższe kroki:
            </p>
            <ol>
              <li>
                Włącz dostęp do panelu menagera pojedynków po utworzeniu systemu ligowego lub turnieju
              </li>
              <li>
                Przejdź na stronę logowania pod adresem: <a href="https://turniej-generator.pl/panel/login" target="_blank" rel="noopener noreferrer">https://turniej-generator.pl/panel/login</a>
              </li>
              <li>
                W formularzu logowania podaj:
                <ul>
                  <li><strong>ID:</strong> <code>{value ? value : "PODANY W PANELU ORGANIZATORA"}</code></li>
                  <li><strong>E-mail:</strong> Adres e-mail*</li>
                </ul>
              </li>
              <li>
                Po kliknięciu przycisku „Zaloguj” otrzymasz wiadomość e-mail z linkiem.
              </li>
              <li>
                Kliknij w link z wiadomości e-mail, aby zalogować się do panelu.
              </li>
            </ol>
            <p>
              *Adres e-mail: Zawodnika, drużyny, zawodnika przypisanego do drużyny lub administrator turnieju.<br />
              - Administrator turnieju widzi wszystkie pojedynki<br />
              - Pozostali widzą tylko pojedynki w których uczestniczą.
            </p>
          </Grid.Column>
          <Grid.Column width={8} textAlign="center">
          {value ? <>
           Link:  <a href={"https://turniej-generator.pl/panel/login/"+value} target="_blank" rel="noopener noreferrer">{"https://turniej-generator.pl/panel/login/"+value}</a>
           <br/>
           <div id="qrCodeContainer">
          <QRCode value={"https://turniej-generator.pl/panel/login/"+value} logoImage={tglh}  ecLevel={"H"}/> 
          </div>
          <br />
                <Button onClick={() => downloadQRCode()}>
                  POBIERZ QRCODE
                </Button>
          </>:""}
          </Grid.Column>
        </Grid.Row>
      </Grid>

    </Message>

    <Header as='h3'>Wprowadzanie wyników i statystyk</Header>
    <Message>
      <ul>
        <li>
          <strong>Dostępność meczów:</strong> W Panelu Zawodnika zobaczysz listę pojedynków. Wyniki możesz wprowadzać tylko dla tych meczów, które jeszcze się nie odbyły.
        </li>
        <li>
          <strong>Wprowadzenie wyników:</strong> Wpisz wynik meczu oraz statystyki zawodników. Po zapisaniu dane zostaną oznaczone jako "OCZEKUJE NA WERYFIKACJĘ". Wynik będzie dostępny na stronie
        </li>
        <li>
          <strong>Zatwierdzenie przez organizatora:</strong> Organizator zweryfikuje i zatwierdzi wyniki. Po zatwierdzeniu mecz będzie zablokowany w panelu i tylko administrator będzie mógł go zmienić.
        </li>
      </ul>
    </Message>

    <Header as='h3'>Dodatkowe informacje</Header>
    <Message>
      <p>
        - W przypadku problemów z logowaniem sprawdź folder SPAM w swojej skrzynce e-mail.<br />
        - Jeśli nadal nie możesz się zalogować, skontaktuj się z organizatorem turnieju.
      </p>
    </Message>


  </Container>
}